/**
 * Página de Pagamentos — Histórico completo
 */

import { Search, Filter } from 'lucide-react';
import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { PageHeader } from '@/components/shared/PageHeader';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

const mockPayments = [
  { id: 'pay-001', invoice_id: 'inv-001', amount: 499, method: 'credit_card', status: 'aprovado', gateway: 'Stripe', transaction_id: 'txn_abc123', created_at: '2025-01-10T12:00:00Z' },
  { id: 'pay-002', invoice_id: 'inv-002', amount: 499, method: 'pix', status: 'aprovado', gateway: 'Asaas', transaction_id: 'pix_def456', created_at: '2025-02-10T14:00:00Z' },
];

export default function PaymentsPage() {
  return (
    <div>
      <PageHeader title="Pagamentos" description="Histórico completo de pagamentos" />

      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Data</TableHead>
              <TableHead>Valor</TableHead>
              <TableHead>Método</TableHead>
              <TableHead>Gateway</TableHead>
              <TableHead>Transação</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mockPayments.map(p => (
              <TableRow key={p.id}>
                <TableCell className="text-sm">{new Date(p.created_at).toLocaleDateString('pt-BR')}</TableCell>
                <TableCell className="text-sm font-medium">R$ {p.amount.toFixed(2)}</TableCell>
                <TableCell><Badge variant="outline" className="text-xs capitalize">{p.method.replace('_', ' ')}</Badge></TableCell>
                <TableCell className="text-sm">{p.gateway}</TableCell>
                <TableCell className="text-xs text-muted-foreground font-mono">{p.transaction_id}</TableCell>
                <TableCell><StatusBadge status={p.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
